import { HttpClient } from '@angular/common/http';
import { App } from 'ionic-angular';
import { Injectable } from '@angular/core';
import { AuthProvider } from '@providers/auth/auth';
import { AlertController } from 'ionic-angular';
import { LoginPage } from '@pages';
import { TranslateService } from '@ngx-translate/core';

@Injectable()
export class SesionProvider {

  constructor(
    public http: HttpClient,
    private authProvider: AuthProvider,
    private alertCtrl: AlertController,
    private translateService: TranslateService,
    private app: App,
  ) {
  }

  async init() {
    try{
      this._init();
    } catch( e ) {
       console.log(e) ;
    }
  }

  private async _init() {
    let jugador = await this.authProvider.getSession();
    let equipo = await this.authProvider.getEquipo();

    let params = {
      _id: jugador._id,
      correo: jugador.correo,
      area: equipo.area._id,
      equipo: equipo._id
    };
    let response = await this.authProvider.verificarSesion(params);

    if(!response.verify) {
      let alert = this.alertCtrl.create({
        subTitle: this.translateService.instant('sesionProvider._init.subTitle'),
        buttons: [this.translateService.instant('sesionProvider._init.buttons')]
      });
      alert.present();
      this.app.getRootNavs()[0].setRoot(LoginPage);
    }
  }

}



// WEBPACK FOOTER //
// ./src/providers/sesion/sesion.ts